import { color } from '@nuvolo/nuux-theme/utils';
import type { CustomChipColors } from '#/common/utils/wrappers/withChip';

export const assetPlanStatusItems = [
  { key: 'draft', label: 'Draft' },
  { key: 'pending_approval', label: 'Pending Approval' },
  { key: 'approved', label: 'Approved' },
  { key: 'rejected', label: 'Rejected' },
];

export const assetPlanActionItems = [
  { key: 'replace', label: 'Replace' },
  { key: 'repair', label: 'Repair' },
  { key: 'address', label: 'Address' },
  { key: 'defer', label: 'Defer' },
  { key: 'ignore', label: 'Ignore' },
];

export const assetPlanItemTypeItems = [
  { key: 'asset', label: 'Asset' },
  { key: 'finding', label: 'Finding' },
  { key: 'capital_need', label: 'Capital Need' },
];

export const assetPlanActionColors: Record<string, CustomChipColors> = {
  repair: {
    backgroundColor: color('info', 'dark', 0.15),
    textColor: color('info', 'dark'),
  },
  address: {
    backgroundColor: color('info', 'dark', 0.15),
    textColor: color('info', 'dark'),
  },
  replace: {
    backgroundColor: color('error', 'dark', 0.15),
    textColor: color('error', 'dark'),
  },
  defer: {
    backgroundColor: color('warn', 'light', 0.15),
    textColor: color('warn', 'light'),
  },
  ignore: {
    backgroundColor: color('ui', 'light', 0.85),
    textColor: '#ffffff',
  },
};

export const assetPlanStatusColors: Record<string, CustomChipColors> = {
  draft: {
    backgroundColor: color('info', 'dark', 0.15),
    textColor: color('info', 'dark'),
  },
  pending_approval: {
    backgroundColor: color('warn', 'light', 0.15),
    textColor: color('warn', 'light'),
  },
  approved: {
    backgroundColor: color('success', 'dark', 0.15),
    textColor: color('success', 'dark'),
  },
  rejected: {
    backgroundColor: color('error', 'dark', 0.15),
    textColor: color('error', 'dark'),
  },
};
